import * as S from "./styles";

const Title = ({ children, dark }) => {
  return <S.Title dark={dark}>{children}</S.Title>;
};

export default Title;
